export default __webpack_public_path__ + "static/media/no-implement-small.892c1e45.svg";